import { useRef, useEffect } from "react";

export default function useClickOutside(ref, callback) {
  useEffect(() => {
    function handleClick(evt) {
      if (callback && ref?.current && !ref?.current?.contains(evt.target)) {
        callback();
      }
    }

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    }
  }, [ref, callback]);
}
